import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=753883d0&scoped=true&"
import script from "./Tasks.vue?vue&type=script&lang=ts&"
export * from "./Tasks.vue?vue&type=script&lang=ts&"
import style0 from "./Tasks.vue?vue&type=style&index=0&id=753883d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753883d0",
  null
  
)

export default component.exports